import { api } from "@/lib/api";
import { API_ENDPOINTS } from "@/utils/constants";

export const getEvents = (params?: Record<string, any>) =>
  api.get(API_ENDPOINTS.CALENDAR.EVENTS, params);
export const getEvent = (id: string) => api.get(API_ENDPOINTS.CALENDAR.GET(id));
export const createEvent = (body: any) =>
  api.post(API_ENDPOINTS.CALENDAR.CREATE, body);
export const updateEvent = (id: string, body: any) =>
  api.patch(API_ENDPOINTS.CALENDAR.UPDATE(id), body);
export const deleteEvent = (id: string) =>
  api.delete(API_ENDPOINTS.CALENDAR.DELETE(id));
export const getEventSubscriptions = (
  id: string,
  params?: Record<string, any>
) => api.get(API_ENDPOINTS.CALENDAR.EVENT_SUBSCRIPTIONS(id), params);

export default {
  getEvents,
  getEvent,
  createEvent,
  updateEvent,
  deleteEvent,
  getEventSubscriptions,
};
